'use client';

import Almanac from '../../../src/routes/Almanac';

export default function AlmanacClient() {
  return <Almanac />;
}
